import { baseApi } from "./baseApi";

const brokerCompensationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompensations: builder.query({
      query: (brokerCompanyId) => ({
        url: `/broker-companies/${brokerCompanyId}/compensation`,
        method: "GET",
      }),
      providesTags: (result, error, brokerCompanyId) => [
        { type: "BrokerCompensation", id: brokerCompanyId },
      ],
    }),

    getActiveCompensation: builder.query({
      query: (brokerCompanyId) => ({
        url: `/broker-companies/${brokerCompanyId}/compensation/active`,
        method: "GET",
      }),
      providesTags: (result, error, brokerCompanyId) => [
        { type: "BrokerCompensation", id: `${brokerCompanyId}-active` },
      ],
    }),

    createCompensation: builder.mutation({
      query: ({ brokerCompanyId, ...body }) => ({
        url: `/broker-companies/${brokerCompanyId}/compensation`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { brokerCompanyId }) => [
        { type: "BrokerCompensation", id: brokerCompanyId },
        { type: "BrokerCompensation", id: `${brokerCompanyId}-active` },
      ],
    }),

    updateCompensation: builder.mutation({
      query: ({ brokerCompanyId, compensationId, ...body }) => ({
        url: `/broker-companies/${brokerCompanyId}/compensation/${compensationId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { brokerCompanyId }) => [
        { type: "BrokerCompensation", id: brokerCompanyId },
        { type: "BrokerCompensation", id: `${brokerCompanyId}-active` },
      ],
    }),

    deleteCompensation: builder.mutation({
      query: ({ brokerCompanyId, compensationId }) => ({
        url: `/broker-companies/${brokerCompanyId}/compensation/${compensationId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { brokerCompanyId }) => [
        { type: "BrokerCompensation", id: brokerCompanyId },
        { type: "BrokerCompensation", id: `${brokerCompanyId}-active` },
      ],
    }),
  }),
});

export default brokerCompensationApi;
